/**
 * Where a guest is asked to sign in: on desktop (the topbar's desktop layout, from 1100px,
 * `--viewportTopbarDesktop`) in the auth modal, over the page they are on; on smaller screens
 * on the sign-in pages. Decided when the guest acts, so only in the browser.
 */
export const AUTH_MODAL_MEDIA_QUERY = '(min-width: 1100px)';

export const signsInWithModal = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(AUTH_MODAL_MEDIA_QUERY).matches;
